import guidImage from './guide_image.png';
import shareSNS from './share_sns.png';
import mockup from './mockup.png';

export const tooltipImage = { guidImage, shareSNS };
export { mockup };
